import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'

export const StyledArticleFeedback = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  gap: 24px;

  width: 100%;
  height: 184px;

  /* Neutral/Neutral-100 */

  border: 1px solid ${theme.colors.neutral100};
  border-radius: 8px;
  .button-group {
    display: flex;
    gap: 16px;
  }
`

export const StyledFeedbackForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  .feedback-status {
    cursor: pointer;
    display: flex;
    align-items: center;

    padding: 12px;
    gap: 10px;
    width: 100%;
    min-height: 52px;

    /* Gray/Gray-50 */
    border: 1px solid transparent;

    background: ${theme.colors.gray50};
    border-radius: ${theme.borderRadius};
    transition: all 300ms ease-in-out;
    &.active {
      background: ${theme.colors.primary50};
      border: 1px solid ${theme.colors.primary200};
    }
  }
  .feedback-disclaimer {
    display: flex;
    gap: 4px;
    ${MediaQueries.mbDown} {
      margin-bottom: 16px;
    }
  }
`
